import { Component, Input } from '@angular/core';
import { CustomerListItem } from '../shared/models/customer-list-view-model';

@Component({
    selector: 'app-customer-list-item',
    templateUrl: './redesign/customer-list-item.component.html',
    styleUrls: ['./redesign/customer-list-item.component.scss'],
    standalone: false
})
export class CustomerListItemComponent {

  @Input() company: CustomerListItem;

  logoFailed = false;

  get showLogo(): boolean {
    return this.company.hasLogo && !!this.company.logoHref && !this.logoFailed;
  }

  get initials(): string {
    return (this.company.name ?? '')
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(word => word.charAt(0))
      .join('');
  }
}
